/**
 * Converts a product name to a URL-friendly slug, truncated at a word
 * boundary so the URL stays readable even for long names.
 */
export function slugify(name, maxLength = 50) {
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")   // strip special chars
    .trim()
    .replace(/\s+/g, "-")           // spaces → hyphens
    .replace(/-+/g, "-");           // collapse duplicate hyphens

  if (slug.length <= maxLength) return slug;

  // Truncate at the last word boundary within maxLength
  const cut = slug.slice(0, maxLength);
  const lastHyphen = cut.lastIndexOf("-");
  return lastHyphen > 0 ? cut.slice(0, lastHyphen) : cut;
}

/** Returns the full path for a product page, e.g. /product/6-grilled-chicken */
export function toProductPath(id, name) {
  return `/product/${id}-${slugify(name)}`;
}
